import { atom } from 'recoil';
import type { AllCoverablesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';

export const notUpdatedCoverablesAtom = atom<AllCoverablesDTO>({
    key: 'notUpdatedCoverables',
    default: undefined
});
